import type { Api } from '@cocoonspace/types/shared/api'
import type { AxiosInstance, AxiosRequestConfig } from 'axios'

import { defineEndpoint } from '../utils/define-endpoint'

export interface ListBookings {
	params?: NonNullable<Api.Operations['listBookings']['parameters']>['query']
	response: Api.Operations['listBookings']['responses']['200']['content']['application/json']
}

export const listBookings = (
	axiosInstance: AxiosInstance,
	overideConfig?: AxiosRequestConfig,
) =>
	defineEndpoint<ListBookings>(
		{
			method: 'get',
			url: '/bookings',
			...overideConfig,
		},
		axiosInstance,
	)
